import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import Layout from './layout';
import ReturningPayfee from './sections/returningPayfee';
 
function Router() {

  const resultStep = useStoreState(state => state.displayResult);
  const setting = useStoreState(state => state.siteSettingsModel);

    useEffect(() => {
        document.querySelector("title").textContent = `${setting.brandSettings.ProductName || ""} - Mastercard`;
    },[]);

  return (
    <>
        <Switch>
          <Route path="/payfee" component={() => <ReturningPayfee />} exact />
          <Route  component={() => <Layout />}  />
        </Switch>
    </>
    
  );
}

export default Router;
